import { correspond } from './menuActif';

/**
 * Sections a deplier par defaut : celle qui contient le chemin courant.
 * Retourne un tableau (0 ou 1 element) plutot qu'une chaine, pour se
 * composer directement avec l'ensemble des sections ouvertes.
 */
export const sectionsParDefaut = (menu, pathname) => {
  const section = (menu ?? []).find((item) =>
    correspond(pathname, item.path)
    || (item.children ?? []).some((enfant) => correspond(pathname, enfant.path)),
  )?.section;

  return section ? [section] : [];
};

/**
 * Nouvel ensemble de sections ouvertes.
 *
 * Accordeon strict : au plus une section ouverte a tout instant. Changer de
 * section REMPLACE l'ouverte au lieu de s'y ajouter.
 *
 * @param prev                 sections ouvertes actuelles, ou null si l'utilisateur n'a jamais choisi
 * @param requises             sections a ouvrir pour le chemin courant (sortie de sectionsParDefaut)
 * @param sectionsPrecedentes  sections du chemin precedent, ou null si aucune navigation connue
 *                             (premier montage, rechargement de page)
 */
export const fusionnerSectionsOuvertes = (prev, requises, sectionsPrecedentes) => {
  if (prev === null) return requises;  // premiere visite : on applique le defaut
  if (!requises.length) return prev;   // chemin hors menu (ex. /mon-profil) : on ne touche a rien
  // Deja exactement l'etat ouvert : renvoyer prev a l'identique. Une nouvelle
  // reference a chaque rendu ferait boucler l'effet indefiniment.
  if (prev.length === requises.length && requises.every((s) => prev.includes(s))) return prev;
  // Aucune navigation connue (rechargement, lien direct). Un etat memorise vide
  // est un repli volontaire, on le respecte. Un etat non vide qui ne contient
  // pas la route active est un residu, pas une preference : personne n'a choisi
  // de garder Sinistres ouverte en etant sur une page Finance.
  if (sectionsPrecedentes === null) return prev.length ? requises : prev;
  // Meme section qu'avant : l'utilisateur n'a pas change de zone, on ne rouvre rien.
  if (requises.every((s) => sectionsPrecedentes.includes(s))) return prev;
  return requises;
};

/**
 * Bascule d'un en-tete de section, en accordeon strict : ouvrir une section
 * referme celle qui l'etait, et refermer la seule ouverte laisse la barre
 * entierement repliee ([] est un etat legitime).
 */
export const basculerSectionExclusive = (prev, titre) =>
  (prev ?? []).includes(titre) ? [] : [titre];
